import _dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';
import duration from 'dayjs/plugin/duration.js';
import isBetween from 'dayjs/plugin/isBetween.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import advancedFormat from 'dayjs/plugin/advancedFormat.js';

_dayjs.extend(utc);
_dayjs.extend(timezone);
_dayjs.extend(duration);
_dayjs.extend(isBetween);
_dayjs.extend(relativeTime);
_dayjs.extend(advancedFormat);

// import from here instead of directly from dayjs to ensure it's
// extended (regardless of what lambda or unit test you're in)
export const dayjs = _dayjs;
